/*
 * @Description: 城市二级页title部分
 * @Version: 2.0
 * @Author: zhouhong07
 * @Date: 2020-02-08 14:25:52
 * @LastEditors: zhouhong07
 * @LastEditTime: 2020-03-06 16:50:37
 */
import React, { useEffect } from 'react' ;
import { getCity } from '../../util/helper' ;
import handleShowTips from './addName';


const CityTitle = () => {
  let temp = decodeURI(window.location.hash).split(":")[1];
  let city = temp.length > 0 ? temp.split("_")[1] : getCity() ;

  return(
    <div className="active-title-block">
      {
        handleShowTips(city) !== "" 
        ? <div className="main-title-block">
            <div className="main-title-img"></div>
            <span>×</span>
            <div className="other-city-title-intro">{handleShowTips(city)}</div>
          </div>
        : <div className="main-title-img"></div>
      }
      <div className="city-title-intro"></div>
      <div className="city-cur-city">{city}站</div>
    </div>
  )
}

export default React.memo(CityTitle) ;